import { useEffect } from "react";

interface JsonLdProps {
  /** Unique DOM id so the script can be cleaned up on unmount */
  id: string;
  schema: Record<string, unknown> | Record<string, unknown>[];
}

/**
 * Injects a JSON-LD <script> tag into <head> and removes it on unmount.
 * Must NOT be included in index.html — it belongs in individual page components.
 */
export default function JsonLd({ id, schema }: JsonLdProps) {
  useEffect(() => {
    // Remove any stale version first
    const existing = document.getElementById(id);
    if (existing) existing.remove();

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      document.getElementById(id)?.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return null;
}
